import { ClientOrderActionTypes } from './orders-actions';

export const initialState = {
  ordersList: [],
  dataLoading: true,
  pdfResultId: undefined,
  pdfResultLoading: false,
  preInvoiceList: [],
  currentPage: 1,
  lastPage: 0,
  extendedListLoading: false,
  complaintRespondTime: null,
  reorderModal: false,
  reorderId: null,
  orderType: 'CURRENT',
};

function clientOrdersReducer(state = initialState, action: any) {
  switch (action.type) {
    case ClientOrderActionTypes.GET_CLIENT_ORDERS: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case ClientOrderActionTypes.SET_CLIENT_ORDERS:
      return {
        ...state,
        ordersList: action?.data?.ordersList,
        lastPage: action?.data?.lastPage,
        currentPage: state.currentPage + 1,
        dataLoading: false,
        extendedListLoading: false,
      };

    case ClientOrderActionTypes.GET_PDF_RESULT:
      return {
        ...state,
        pdfResultId: action?.data?.pdfResultId,
        pdfResultLoading: true,
      };

    case ClientOrderActionTypes.SET_PDF_RESULT_LOADING:
      return {
        ...state,
        pdfResultLoading: false,
      };

    case ClientOrderActionTypes.SET_CLIENT_PRE_INVOICE:
      return {
        ...state,
        preInvoiceList: action?.data?.preInvoiceList,
        dataLoading: false,
      };

    case ClientOrderActionTypes.GET_EXTENDED_ORDER_LIST:
      return {
        ...state,
        extendedListLoading: true,
      };

    case ClientOrderActionTypes.SET_CLIENT_ORDERS_INITIAL:
      return {
        ...initialState,
      };

    case ClientOrderActionTypes.SET_COMPLAINT_RESPOND_TIME:
      return {
        ...state,
        complaintRespondTime: action?.data?.complaintRespondTime,
      };

    case ClientOrderActionTypes.SET_REORDER_MODAL:
      return {
        ...state,
        reorderModal: action?.data?.open,
        reorderId: action?.data?.orderId,
      };

    case ClientOrderActionTypes.SET_ORDER_TYPE:
      return {
        ...state,
        orderType: action?.data?.orderType,
        ordersList: [],
        dataLoading: true,
        preInvoiceList: [],
        currentPage: 1,
        lastPage: 0,
      };

    default:
      return state;
  }
}

export default clientOrdersReducer;
